import { FormControlLabel, FormGroup, Grid, Paper, Switch, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { useNavigate, useParams } from "react-router-dom";
import { PrimaryButton } from "../../_components/button/primary.button";
import { TextValidatorHcs } from "../../_components/textValidator/textValidatorHcs";
import { toastr } from "../../_components/toastr/toastr";
import { stringToDateFormat } from "../../_helpers/format.helper";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { accountService } from "../../_services/accounts.service";
import { mediaInformationService } from "../../_services/mediaInformation.service";

export function UserMediaManage() {

    const { userId } = useParams<{ userId: string }>();

    let navigate = useNavigate();

    const resetData = () => ({
        licenseNumber: "",
        bibNumber: '',
        representing: '',
        journalist: false,
        radio: false,
        photographer: false,
        television: false,
        other: false,
        otherDescription: '',
        licenseExpirationDate: '',
        userId: userId
    });

    const [isLoading, setIsLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [data, setData] = useState<any>(resetData);

    useEffect(() => {
        fetchData(userId || accountService.currentUserValue.id);
    }, []);

    function fetchData(id: string) {

        setIsLoading(true)
        return mediaInformationService
            .get(id)
            .then(
                (json) => {
                    if (json) {
                        json.licenseExpirationDate = stringToDateFormat(json.licenseExpirationDate);
                    }
                    setData(json);
                }, () => {

                }
            )
            .finally(() => {
                setIsLoading(false);
            });
    }

    function handleChange(event: any) {
        setData((__data: any) => { return { ...__data, [event.target.name]: event.target.value } });
    };
    function handleSwitchChange(event: any) {
        setData((__data: any) => { return { ...__data, [event.target.name]: !__data[event.target.name] } });
    };
    function handleDateChange(event: any) {
        setData((__data: any) => {
            return { ...__data, [event.target.name]: stringToDateFormat(event.target.value) }
        });
    };

    function submit() {
        setIsLoading(true);
        setIsSaving(true);
        return mediaInformationService
            .update({ ...data, userId: userId })
            .then(
                (json) => {
                    if (json) {
                        json.licenseExpirationDate = stringToDateFormat(json.licenseExpirationDate);
                    }
                    setData(json);
                    toastr.success("Address saved successfully");
                }, handleErrorResponse
            )
            .finally(() => {
                setIsLoading(false);
                setIsSaving(false)
            });
    }

    return (
        <>
            {(!isLoading && data && !!data.licenseNumber) &&
                <Paper>
                    <ValidatorForm
                        onSubmit={() => { }}
                        noValidate>

                        <Grid container spacing={2} sx={{ mt: 0 }}>

                            <Grid item xs={12}>
                                <Typography variant="h6" textAlign="center">Media Information</Typography>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextValidatorHcs
                                    key="bibNumber"
                                    name="bibNumber"
                                    label="Bib Number"
                                    fullWidth
                                    disabled={!accountService.isAdmin}
                                    value={data.bibNumber}
                                    onChange={handleChange}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextValidatorHcs
                                    key="representing"
                                    name="representing"
                                    label="Representing"
                                    fullWidth
                                    disabled={!accountService.isAdmin}
                                    value={data.representing}
                                    onChange={handleChange}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <FormGroup>
                                    <FormControlLabel disabled={!accountService.isAdmin} control={<Switch name="journalist" onChange={handleSwitchChange} checked={data.journalist} value={data.journalist} />} label="Journalist" />
                                    <FormControlLabel disabled={!accountService.isAdmin} control={<Switch name="radio" onChange={handleSwitchChange} checked={data.radio} value={data.radio} />} label="Radio" />
                                    <FormControlLabel disabled={!accountService.isAdmin} control={<Switch name="photographer" onChange={handleSwitchChange} checked={data.photographer} value={data.photographer} />} label="Photographer" />
                                    <FormControlLabel disabled={!accountService.isAdmin} control={<Switch name="television" onChange={handleSwitchChange} checked={data.television} value={data.television} />} label="Television" />
                                    <FormControlLabel disabled={!accountService.isAdmin} control={<Switch name="other" onChange={handleSwitchChange} checked={data.other} value={data.other} />} label="Other" />
                                </FormGroup>
                            </Grid>

                            <Grid item xs={12}>

                                <PrimaryButton
                                    type="button"
                                    variant="success"
                                    onClick={submit}
                                    disabled={isLoading || isSaving || !accountService.isAdmin}>

                                    Update Media Information
                                </PrimaryButton>
                            </Grid>


                        </Grid>

                    </ValidatorForm >
                </Paper>
            }
        </>
    );

}
